// extracted by mini-css-extract-plugin
export default {"filterWrapper":"DashboardFilter_filterWrapper__2OtAh","applyButton":"DashboardFilter_applyButton__r-Uui"};